import React from 'react';
import { Card, CardContentLine } from './MetricsCard';

export default function CampaignsStatsCard({ metrics }) {
  return (
    <Card>

      <CardContentLine
        left="Campaigns Sent"
        right={metrics.campaignMetrics?.noOfCampaigns || '0'}
      />
      <CardContentLine
        left="Total Messages Sent"
        right={metrics.campaignMetrics?.totalMessagesSent || '0'}
      />
      <CardContentLine
        left="# of Conversions"
        right={metrics.campaignMetrics?.noOfConversions || '0'}
      />
    </Card>
  );
}
